/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity } from "react-native";

import { SelfObject } from "store/types";
import { useHistory } from "react-router";

import { Text, ProfileImage } from "UpduoLibrary";
import { upduoPrimaryBlack } from "config/UpduoColors";
import * as UpduoAnalytics from "config/UpduoAnalytics";

export default function AccountButton({
  selfObject,
}: {
  selfObject: SelfObject;
}) {
  const history = useHistory();

  return (
    <TouchableOpacity
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        //@ts-ignore
        cursor: "pointer",
        padding: 10,
      }}
      onPress={() => {
        UpduoAnalytics.logEvent("user-nav-gotodashboard");
        history.push("/user-dashboard");
      }}
    >
      <ProfileImage userObject={selfObject} size={40} />
      <Text
        style={{
          color: upduoPrimaryBlack,
          fontSize: 14,
          marginLeft: 10,
        }}
      >{`${selfObject.firstName} ${selfObject.lastName}`}</Text>
    </TouchableOpacity>
  );
}
